import { DECORATION_MERCHANT_UPDATES } from '@constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import Rowbox from '../Common/Rowbox'
import SanDaUpdates from './SanDaUpdates'
import Store from './store'
import Updates from './Updates'

@inject('decorationStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.decorationStore)
  }

  componentDidMount() {
    this.store.getMerchantUpdates()
  }

  render() {
    const { showMerchantUpdates, updates } = this.store
    const isWaterFall = isSiDaProperty()

    return showMerchantUpdates ? (
      <Rowbox
        type={DECORATION_MERCHANT_UPDATES}
        store={this.props.decorationStore}
        style={{
          height: 'auto',
          flexDirection: 'column',
          padding: isWaterFall ? '0 12px' : '0 16px'
        }}
        vCenter={false}
      >
        {isWaterFall ? (
          <SanDaUpdates data={updates} store={this.store} />
        ) : (
          <Updates data={updates} store={this.store} />
        )}
      </Rowbox>
    ) : null
  }
}
